export default __webpack_public_path__ + "static/media/lose.2e99f663.gif";